import React from "react";
import { Button } from "../../common/Button/Button";
import ReactTable from "react-table";
import "react-table/react-table.css";
import moment from "moment";
import ReactStars from "react-rating-stars-component";
import withFixedColumns from "react-table-hoc-fixed-columns";
import "react-table-hoc-fixed-columns/lib/styles.css";
import Pagination from "../../common/Pagination/Pagination";
const ReactTableFixedColumns = withFixedColumns(ReactTable);

export default function ESPCustomerFeedback(props)
{
    const renderQuestions = (original) => {
        return original.feedback_given.map((feedback,i) => {
            return(
                <>
                    {
                        i===0?
                        <div className="conv-mb15">
                            <label className="feedback-question-label">{feedback.que}</label>
                            <ReactStars
                                className={"star-border"}
                                count={5}
                                size={25}
                                color="white"
                                activeColor="#76287C"
                                value={feedback.ans||0}
                                edit={false}
                            />
                        </div>
                        :
                        <div className="conv-mb15">
                            <label className="feedback-question-label">{feedback.que}</label>
                            <label className="feedback-ans-label">{feedback.ans}</label>
                        </div>
                    }
                </>
            )
        })
      }

     const columns = [
		{
			id: "service_id",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
			Header: "Service ID",
			accessor: "service_id",
			width:100,
		},
		{
			id: "service_name",
			Header: "Service Name",
			headerStyle:{'borderBottom':'solid 1px #ccc'},
			accessor: "service_name",
            style: { 'whiteSpace': 'unset' },
            width:200,
		},
		{
			id: "sFirstName"+"service_id",
			Header: "Customer Details",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
			accessor: "service_id",
            style: { 'whiteSpace': 'unset' },
            width:330,
			Cell: ({ original }) => (
				<>
                   <div className="conv-mb30">
                        <span className="inline-label feedback-customer-label">Name</span>
                        <span style={{wordBreak:"break-all",float:"right",width:"210px"}}>{original.customer_details.name}</span>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div className="conv-mb30">
                        <span className="inline-label feedback-customer-label">E-mail ID</span>
                        <span style={{wordBreak:"break-all",float:"right",width:"210px"}}>{original.customer_details.email}</span>
                    </div>
                    <div style={{clear:"both"}}></div>
                    <div>
                        <span className="inline-label feedback-customer-label">Phone No.</span>
                        <span style={{wordBreak:"break-all",float:"right",width:"210px"}}>{original.customer_details.contact_number}</span>
                    </div>
				</>
			),
		},
		{
			id: "facilitator_name",
			Header: "Facilitator Name",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
			accessor: "facilitator_name",
            style: { 'whiteSpace': 'unset' },
            width:220,
			Cell: ({ original }) => (
				<>
					{
						original.facilitator_name?original.facilitator_name:""
					}
				</>
			),
		},
		{
			id: "feedback_given",
			Header: "Feedback Given",
			headerStyle:{'whiteSpace': 'unset','borderBottom':'solid 1px #ccc'},
			accessor: "service_id",
            style: { 'whiteSpace': 'unset' },
            Cell: ({ original }) => (
                renderQuestions(original)
			),
		},
    ];

    return (
            <ReactTableFixedColumns
                minRows={0}
                data={props.data || []}
                columns={columns}
                //manual
                //defaultPage={props.page}
                //pages={props.pages}
                //page={props.page}
                pageSize={props.data.length}
                sortable={false}
                //defaultPageSize={10}
                showPagination={false}
                //pageSizeOptions={[10,20,30]}
                //onFetchData={(state, instance) => {
                    //props.fetchESPCustomerFeedbackData(instance, false);
                //}}
                //onPageSizeChange={props.onPageSizeOptionChange}
                PaginationComponent={Pagination}
                style={{overflowY: "initial",height: "500px"}}			
                /*NextComponent={(instance) => (
                    <Button className="mt3" {...instance}>
                        Next
                    </Button>
                )}*/
                /*PreviousComponent={(instance) => (
                    <Button className="mt3" {...instance}>
                        Previous
                    </Button>
                )}*/
                className="-striped hide-scrollbar"
            />
    )
}